"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerNMRium = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_1 = require("react-science/ui");
const react_use_1 = require("react-use");
const assignment_1 = require("../assignment");
const GlobalContext_1 = require("../context/GlobalContext");
const KeyModifierContext_1 = require("../context/KeyModifierContext");
const LoggerContext_1 = require("../context/LoggerContext");
const PreferencesContext_1 = require("../context/PreferencesContext");
const Alert_1 = require("../elements/popup/Alert");
const Modal_1 = require("../elements/popup/Modal");
const highlight_1 = require("../highlight");
const SpinnerContext_1 = require("../loader/SpinnerContext");
const preferencesReducer_1 = __importStar(require("../reducer/preferences/preferencesReducer"));
const export_1 = require("../utility/export");
const InnerNMRiumContents_1 = require("./InnerNMRiumContents");
const NMRiumStateProvider_1 = __importDefault(require("./NMRiumStateProvider"));
function InnerNMRium({ data: nmriumData, workspace, customWorkspaces, preferences, getSpinner = SpinnerContext_1.defaultGetSpinner, onChange, emptyText, innerRef, }) {
    const rootRef = (0, react_1.useRef)(null);
    const elementsWrapperRef = (0, react_1.useRef)(null);
    const viewerRef = (0, react_1.useRef)(null);
    const [enableFullscreen, , disableFullscreen, toggleFullscreen] = (0, ui_1.useOnOff)(false);
    const mainDivRef = (0, react_1.useRef)(null);
    const isFullscreenEnabled = (0, react_use_1.useFullscreen)(rootRef, enableFullscreen, {
        onClose: disableFullscreen,
    });
    const [preferencesState, dispatchPreferences] = (0, react_1.useReducer)(preferencesReducer_1.default, preferencesReducer_1.preferencesInitialState, preferencesReducer_1.initPreferencesState);
    (0, react_1.useEffect)(() => {
        rootRef.current?.focus();
    }, [isFullscreenEnabled]);
    (0, react_1.useEffect)(() => {
        dispatchPreferences({
            type: 'INIT_PREFERENCES',
            payload: {
                preferences,
                workspace,
                customWorkspaces,
                dispatch: dispatchPreferences,
            },
        });
    }, [customWorkspaces, preferences, workspace]);
    (0, react_1.useImperativeHandle)(innerRef, () => ({
        getSpectraViewerAsBlob: () => {
            return rootRef?.current ? (0, export_1.getBlob)(rootRef.current, 'nmrSVG') : null;
        },
    }), []);
    return ((0, jsx_runtime_1.jsx)("div", { ref: mainDivRef, style: { height: '100%', position: 'relative' }, children: (0, jsx_runtime_1.jsx)(GlobalContext_1.GlobalProvider, { value: {
                rootRef: rootRef.current,
                elementsWrapperRef: elementsWrapperRef.current,
                viewerRef: viewerRef.current,
            }, children: (0, jsx_runtime_1.jsx)(PreferencesContext_1.PreferencesProvider, { value: preferencesState, children: (0, jsx_runtime_1.jsx)(LoggerContext_1.LoggerProvider, { children: (0, jsx_runtime_1.jsx)(KeyModifierContext_1.KeyModifiersProvider, { children: (0, jsx_runtime_1.jsx)(Alert_1.AlertProvider, { wrapperRef: elementsWrapperRef.current, children: (0, jsx_runtime_1.jsx)(NMRiumStateProvider_1.default, { onChange: onChange, nmriumData: nmriumData, children: (0, jsx_runtime_1.jsx)(Modal_1.ModalProvider, { wrapperRef: elementsWrapperRef.current, children: (0, jsx_runtime_1.jsx)(highlight_1.HighlightProvider, { children: (0, jsx_runtime_1.jsx)(assignment_1.AssignmentProvider, { children: (0, jsx_runtime_1.jsx)(SpinnerContext_1.SpinnerProvider, { value: getSpinner, children: (0, jsx_runtime_1.jsx)(InnerNMRiumContents_1.InnerNMRiumContents, { isFullscreenEnabled: isFullscreenEnabled, toggleFullscreen: toggleFullscreen, emptyText: emptyText, mainDivRef: mainDivRef, elementsWrapperRef: elementsWrapperRef, rootRef: rootRef, viewerRef: viewerRef }) }) }) }) }) }) }) }) }) }) }) }));
}
exports.InnerNMRium = InnerNMRium;
